import { render, staticRenderFns } from "./HeroesPickStatus.vue?vue&type=template&id=42222484&"
import script from "./HeroesPickStatus.vue?vue&type=script&lang=js&"
export * from "./HeroesPickStatus.vue?vue&type=script&lang=js&"
import style0 from "./HeroesPickStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports